<template lang="pug">
    m-block-form-fields(:tooltip="$t(`modules.blocks.forms.${name}.tooltip`)" required :offset="true")
        template(#title="") {{$t(`modules.blocks.forms.${name}.title`)}}

        m-block-form-fields(child enabled :offset="false" ref="address" )
            template(#switch-label="") {{$t(`modules.blocks.forms.${name}.switches.address`)}}

            template
                e-input-object-address(
                    :rules="{requiredIfEmpty: $attrs.form.geolocation}"
                    v-model="$attrs.form.address")

                v-layout(wrap)
                    v-flex(md4)
                        e-input-object-postcode(
                            :rules="{requiredIfEmpty: $attrs.form.geolocation,numeric: true,length: 5}"
                            v-model="$attrs.form.postcode")

                    v-flex(md8)
                        e-input-object-locality(
                            :rules="{requiredIfEmpty: $attrs.form.geolocation}"
                            v-model="$attrs.form.locality")


        m-block-form-fields(child :offset="false")
            template(#switch-label="") {{$t(`modules.blocks.forms.${name}.switches.geolocation`)}}

            template
                v-layout(wrap)
                    v-flex(xs12)
                        e-input-geolocation-latitude(v-if="$attrs.form.geolocation.latitude != null" v-model="$attrs.form.geolocation.latitude")

                    v-flex(xs12)
                        e-input-geolocation-longitude(v-if="$attrs.form.geolocation.longitude != null" v-model="$attrs.form.geolocation.longitude")

                    v-flex(xs12)
                        v-layout(wrap justify-end)
                            v-flex(shrink pb-3)
                                e-button-primary(
                                    class="ma-0"
                                    :loading="(!modalClosed && loading)"
                                    @click="determine") {{ $t(`modules.blocks.forms.${name}.buttons.geolocation`) }}
</template>

<script>
    import MBlockFormFields from "@modules/blocks/form/m-block-form-fields";
    import {createNamespacedHelpers} from 'vuex';
    const {mapGetters} = createNamespacedHelpers('dialogs');
    import blockFormFieldsToggle from "@mixins/validation/_blockFormFieldsToggle";

    let name = 'm-block-form-object-address';

    export default {
        name: name,
        inject: ['$validator'],
        mixins: [blockFormFieldsToggle],
        components: {MBlockFormFields},
        props: {
            name: {
                type: String,
                default: name
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                modalClosed: false
            }
        },
        watch: {
            isModalOpened(nv, ov) {
                if(nv == false && ov == true) {
                    this.modalClosed = true
                }
            }
        },
        computed: {
            ...mapGetters(['isOpened']),

            isModalOpened() {
                return this.isOpened('geolocationMap');
            },
            watchOnBlocks() {
                return [
                    {
                        ref: this.$refs.address,
                        fields: [
                            'e-input-object-address',
                            'e-input-object-postcode',
                            'e-input-object-locality'
                        ]
                    }
                ]
            }
        },
        methods: {
            determine() {
                this.modalClosed = false;
                this.$emit('determine:geolocation');
            }
        }
    }
</script>

<style scoped>

</style>
